const Client = ({prm}) =>{
  return (                     
    <div className="client-logo1">
        <img src={prm.image} alt={prm.name} />
    </div>
    )
}
export default Client